import { useEffect, useRef } from 'react';

export function useOuterClick(callback: (e: MouseEvent) => void) {
  const callbackRef = useRef<(e: MouseEvent) => void | null>(null);
  const innerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => { callbackRef.current = callback; });

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (!innerRef.current) return;
      if (!callbackRef.current) return;
      if (innerRef.current.contains(e.target as Node)) return;

      callbackRef.current(e);
    };

    document.addEventListener('click', handleClick);

    return () => document.removeEventListener('click', handleClick);
  }, []);

  return innerRef;
}